import { waitAsync } from '../utils';
import { Route } from 'react-router-dom';

const ListPointsAction = "LIST_POINTS";
const Waiting = "WAITING_POINTS";

const initialState = {
    list: [],
    nowWainting: false,
};
export const actionCreators = {
    /**
     * ポイント集計情報リストを取得します。
     */
    listPointAggregates: (token, nengetsu) => async (dispatch) => {
        const routeurl = `api/user/pointAggregates/list?nengetsu=${nengetsu}`;

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;
            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {
                    const list = resp.result;
                    dispatch({ type: ListPointsAction, list });
                    return list;
                } else {

                    throw new Error(resp.error_message || 'データ取得に失敗しました。');
                }
            } else {
                throw new Error('データ取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },
    /**
     * 一覧を初期化します。
     */
    initListInfo: () => async (dispatch) => {
        dispatch({ type: ListPointsAction, list: [], nowWainting: false });
    },
 }

export const reducer = (state, action) => {
    state = state || initialState;
    
    if (action.type === Waiting) {
        return {
            ...state,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ListPointsAction) {
        return {
            ...state,
            list: action.list,
            nowWainting: action.nowWainting
        };
    }
    return state;
}